import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

export interface NotificationWelcomeModalData {
  unreadCount: number;
}

@Component({
  selector: 'app-notification-welcome-modal',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  templateUrl: './notification-welcome-modal.component.html',
  styleUrl: './notification-welcome-modal.component.css',
})
export class NotificationWelcomeModalComponent {
  private readonly dialogRef = inject(MatDialogRef<NotificationWelcomeModalComponent>);
  private readonly router = inject(Router);
  readonly data = inject<NotificationWelcomeModalData>(MAT_DIALOG_DATA);

  onView(): void {
    this.dialogRef.close();
    this.router.navigate(['/information-hub/notifications']);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
